import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Icon, { SearchOutlined } from '@ant-design/icons';
import { media } from 'helpers/MediaHelper';
import { cancelEnter } from 'helpers/KeyboardHelper';
import { Input } from '../Input/Input';

const StyledInput = styled(Input)`
  width: 320px;

  ${media.mobile`
    /* calc(100% of the page width - leftMargin - rightMargin) */
    width: 100%;
    margin-bottom: 16px;
  `};
`;

export const TableSearch = ({ onChange, searchTerm = '', isMobile }) => {
  const SearchIcon = <Icon component={SearchOutlined} />;

  return (
    <StyledInput
      data-testid="table-search"
      placeholder="Search"
      onChange={onChange}
      suffix={SearchIcon}
      value={searchTerm}
      size={isMobile ? 'large' : 'default'}
      onKeyPress={cancelEnter}
    />
  );
};

TableSearch.propTypes = {
  onChange: PropTypes.func.isRequired,
  searchTerm: PropTypes.string.isRequired,
  isMobile: PropTypes.bool,
};

TableSearch.defaultProps = {
  onChange: () => {},
  searchTerm: '',
  isMobile: false,
};
